const REPORT_CACHE_RESET_KEY_PREFIX = 'browserReportCacheLastReset'

const REPORT_CACHE_KEYS = [
  'homeData',
  'homeGetPortfoliosApiData',
  'transactionApiDataLastUpdated',
  'transactionReportStartDate',
  'transactionReportEndDate'
]

const getStorage = () => {
  if (typeof window === 'undefined') return null
  return window.localStorage
}

export const getLocalDateKey = (date = new Date()) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const getUserReportCacheResetKey = user => {
  const userIdentifier = user?.userId ?? user?.id ?? user?.userName ?? user?.email ?? 'anonymous'
  return `${REPORT_CACHE_RESET_KEY_PREFIX}:${userIdentifier}`
}

export const clearBrowserReportCache = (storage = getStorage()) => {
  if (!storage) return

  REPORT_CACHE_KEYS.forEach(key => storage.removeItem(key))
}

export const resetBrowserReportCacheOncePerDay = (user, storage = getStorage()) => {
  if (!storage || !user) return false

  try {
    const dateKey = getLocalDateKey()
    const resetKey = getUserReportCacheResetKey(user)

    if (storage.getItem(resetKey) === dateKey) {
      return false
    }

    clearBrowserReportCache(storage)
    storage.setItem(resetKey, dateKey)
    return true
  } catch (error) {
    console.error('Failed to reset browser report cache:', error)
    return false
  }
}
